module.exports = __webpack_public_path__ + "img/coronalabs.242f5dbc.jpg";